/** Latin digits with Arabic scale words -- the convention in Saudi dashboards. */
const nf = new Intl.NumberFormat("ar-SA-u-nu-latn", { maximumFractionDigits: 1 });
const nfInt = new Intl.NumberFormat("ar-SA-u-nu-latn", { maximumFractionDigits: 0 });

/** 740000 -> "740 ألف", 122000000 -> "122 مليون". Used for big numbers and axes. */
export function compact(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1e9) return `${nf.format(n / 1e9)} مليار`;
  if (abs >= 1e6) return `${nf.format(n / 1e6)} مليون`;
  if (abs >= 1000) return `${nf.format(n / 1000)} ألف`;
  return nfInt.format(n);
}

/** Full precision with separators, for tooltips. */
export function full(n: number): string {
  return nfInt.format(n);
}

export function withUnit(text: string, unit?: string): string {
  if (!unit) return text;
  return unit === "%" ? `${text}%` : `${text} ${unit}`;
}

// RAFED chart series: distinct blues and teals. Coral is reserved for alerts.
export const TILE_COLORS = [
  "#09b8d7", "#062f5f", "#247aa0", "#087d70",
  "#83cdd6", "#506f91", "#067da1", "#56aab8",
];

export const CHART_THEME = { grid: "#dce7ef", label: "#58748c", primary: "#067da1", surface: "#ffffff", font: "Almarai" };
export const colorAt = (i: number) => TILE_COLORS[i % TILE_COLORS.length];
